/**
 * Градации сёл по числу отклонений (US-04.9.1 FR-3.1): без критических ·
 * 1–2 · 3–4 · 5 и более — общие для плашки и карточки «Отклонения».
 * Пороги — раскраска демо-прототипа, официальных нормативов нет (FR-3.4).
 */
export type SnpGrade = 'none' | 'low' | 'mid' | 'high';

export const SNP_GRADES: SnpGrade[] = ['none', 'low', 'mid', 'high'];

export const gradeOf = (count: number): SnpGrade => {
  if (count === 0) return 'none';
  if (count <= 2) return 'low';
  if (count <= 4) return 'mid';
  return 'high';
};

export const GRADE_DOT: Record<SnpGrade, string> = {
  none: 'bg-brand-500',
  low: 'bg-status-warning',
  mid: 'bg-status-danger',
  high: 'bg-status-critical',
};

export const GRADE_TEXT: Record<SnpGrade, string> = {
  none: 'text-brand-700',
  low: 'text-status-warning',
  mid: 'text-status-danger',
  high: 'text-status-critical',
};
